/**
 * VideoHistory.jsx
 * Recent videos for the brand, under the Video screen. Choosing one shows it
 * in the Output panel, where it can be tweaked or used in a post.
 *
 * Dependencies: services/api.js, utils/video.js, utils/time.js
 */

import { api } from '../../services/api.js';
import { formatLondon } from '../../utils/time.js';
import { gbp } from '../../utils/video.js';

const LABEL = {
  starting: 'Starting',
  processing: 'Generating',
  saving: 'Saving',
  saved: 'Saved',
  failed: 'Failed',
  canceled: 'Cancelled',
};

const BADGE = {
  saved: 'badge--ok',
  failed: 'badge--danger',
  canceled: '',
};

export default function VideoHistory({ jobs, currentId, onOpen }) {
  if (jobs.length === 0) return null;

  return (
    <section className="card">
      <div className="card__head">
        <div className="card__head-text">
          <h2>Recent videos</h2>
          <p>The last 30 for this brand. Saved ones are in the library too.</p>
        </div>
      </div>

      <div className="vid-history">
        {jobs.map((job) => {
          const p = job.params ?? {};
          return (
            <button
              type="button"
              key={job.id}
              className={`vid-history__item${job.id === currentId ? ' is-current' : ''}`}
              onClick={() => onOpen(job.id)}
            >
              <span className="vid-history__thumb">
                {job.status === 'saved' && job.media_id ? (
                  <video src={`${api.media.rawUrl(job.media_id)}#t=0.5`} muted playsInline preload="metadata" />
                ) : (
                  <span className={`badge ${BADGE[job.status] ?? 'badge--accent'}`}>{LABEL[job.status] ?? job.status}</span>
                )}
              </span>
              <span className="vid-history__text">
                <span className="vid-history__prompt">{job.prompt}</span>
                <span className="row__sub">
                  {formatLondon(job.created_at)} · {p.audio ? 'audio' : `${p.duration}s`} · {p.resolution}
                  {p.draft ? ' draft' : ''} · ≈ {gbp(job.estimate_pence)}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
